<template>
  <tabs
    v-if="restaurant"
    :tab-name="['Detail', 'Reservations', 'Notes']"
    :tab-icon="['event_available', 'book_online', 'text_snippet']"
    class="page-subcategories"
    nav-pills-icons
    color-button="primary"
  >
    <template slot="tab-pane-1">
      <restaurant-edit :restaurant="restaurant" />
    </template>

    <template slot="tab-pane-2">
      <restaurant-tabs-reservations :restaurant="restaurant" />
    </template>

    <template slot="tab-pane-3">
      <restaurant-tabs-notes :restaurant="restaurant" />
    </template>
  </tabs>
</template>

<script>
import { Tabs } from "@/components";

import RestaurantEdit from "./RestaurantEdit";
import RestaurantTabsReservations from "./RestaurantTabsReservations";
import RestaurantTabsNotes from "./RestaurantTabsNotes";

export default {
  props: ["restaurant"],

  components: {
    Tabs,
    RestaurantEdit,
    RestaurantTabsReservations,
    RestaurantTabsNotes
  },

  data() {
    return {};
  },

  computed: {},

  methods: {}
};
</script>
